<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__budget}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.companyId" filterable clearable placeholder="请选择公司">
            <el-option
                    v-for="item in companys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.city" filterable clearable placeholder="请选择城市">
            <el-option
                    v-for="item in citys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.scheduledDate"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:budget:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:budget:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" label="公司" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="city" label="城市" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="topLimitMoney" label="预算金额" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="scheduledDate" label="预算日期" header-align="center" align="center" sortable :formatter="convertDate" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="numberOfPeopleAssignedToday" label="今日分配人数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productType" label="产品类型" header-align="center" align="center">
          <template slot-scope="scope">
            {{ getText(scope.row.productType) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:budget:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <!-- <el-button v-if="$hasPermission('sys:budget:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './budget-add-or-update'
import debounce from "lodash/debounce";
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/budget/page',
        getDataListIsPage: true,
        exportURL: '/sys/budget/export',
        deleteURL: '/sys/budget',
        deleteIsBatch: true
      },
      loanTypes:[],
      citys: [],
      companys:[],
      dataForm: {
        id: '',
        city:'',
        companyId:'',
        scheduledDate:''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.query()
      this.getCityOptions();
      this.getCompanysOptions();
      this.getLoanTypeOptions();
      
    }
  },
  methods: {
    convertDate(row,column){
      if (row.scheduledDate==null || row.scheduledDate==""){
        return null;
      }
      return row.scheduledDate.substring(0,10)
    },
    getText(v){
      if(!v) return;
    
      return this.loanTypes.filter(item => item.value == v)[0]?.label
    },
    //初始化下拉框中的选项
    async getCityOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.citys.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    //初始化贷款标识下拉框中的选项
    async getLoanTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=loan_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.loanTypes=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.loanTypes.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.companys.push({label:element.name,value:element.id})
          })
        }
      }).catch(() => {})
    }
  }
}
</script>
